<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <div style="background-color: #e6e6e6;">
      <div class="main-con" >
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>海量数据</el-breadcrumb-item>
            <el-breadcrumb-item>个人中心</el-breadcrumb-item>
            <el-breadcrumb-item>我的考试</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="exam-contetn">
          <div style="flex: 1;">
            <div class="exam-contetn-item">
              <p class="exam-contetn-item-title">{{item.examPaperName}}</p>
              <p class="exam-contetn-item-score">
                <span>总分：{{item.paperScore}}分</span>
                <span>时长：{{item.doTime | formatSeconds}}秒</span>
              </p>
              <div class="exam-contetn-item-scantron">
                <p class="exam-contetn-item-scantron-p">
                  <span class="exam-contetn-item-scantron-card">答题卡</span>
                  <span class="exam-contetn-item-scantron-type">状态说明</span>
                </p>
                <div class="exam-contetn-item-scantron-state">
                  <div class="exam-contetn-item-scantron-state-imgs">
                    <p style="background: #34bb5c;"></p>
                    <span>正确</span>
                  </div>
                  <div class="exam-contetn-item-scantron-state-imgs">
                    <p style="background: #ff2424;"></p>
                    <span>错误</span>
                  </div>
                </div>
              </div>
              <ul>
                <li v-for="item,index in questions" :key="index" :style="{color:item.correctFlag==1?'#34BB5B':'#FF3030'}">{{ index+1 }}</li>
              </ul>
            </div>
          </div>
          
          <!-- 试题 -->
          <div style="width: 75%;">
            <div class="head">
              <p class="title">解析</p>
              <el-checkbox v-model="checked">仅看错题</el-checkbox>
            </div>
            <div class="exam-contetn-text">
              <ul v-if="!checked">
                <li v-for="item,index in questions" :key="index">
                  <p class="exam-contetn-text-ranking">第{{index+1}}题
                    <span v-if="item.questionType==1">【单选题】</span>
                    <span v-else-if="item.questionType==2">【多选题】</span>
                    <span v-else-if="item.questionType==3">【判断题】</span>
                    <span v-else-if="item.questionType==4">【填空题】</span>
                    <span v-else-if="item.questionType==6">【实践题】</span>
                  </p>
                  <div class="exam-contetn-text-title">
                    <p>{{item.title}}（{{item.score}}分）</p>
                  </div>
                  <div class="exam-contetn-text-radio">
                    <!-- 单选题 -->
                    <el-radio-group v-model="item.answerContent" v-if="item.questionType==1">                   
                      <el-radio disabled :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{ itemi.prefix + ' ' +itemi.content }}</el-radio>
                    </el-radio-group>

                     <!-- 多选题 -->
                    <el-checkbox-group v-model="item.answers" v-else-if="item.questionType==2">
                      <el-checkbox disabled :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{ itemi.prefix + ' ' +itemi.content }}</el-checkbox>
                    </el-checkbox-group>

                    <!-- 判断题 -->
                    <el-radio-group v-model="item.answerContent" v-else-if="item.questionType==3">
                      <el-radio disabled :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{ itemi.prefix + ' ' +itemi.content }}</el-radio>
                    </el-radio-group>

                    <!-- 填空题 -->
                    <div class="exam-contetn-text-input" v-for="itemi,indexi in item.answerContent" :key="indexi" v-else-if="item.questionType==4">
                      <p>{{ indexi+1 }}.</p>
                      <el-input disabled :placeholder="itemi" @paste.native.capture.prevent="handlePaste"></el-input>
                    </div>

                    <!-- 填空题 -->
                    <div class="exam-contetn-text-input" v-else-if="item.questionType==6">
                      <el-input type="textarea" disabled :placeholder="item.answerContent" @paste.native.capture.prevent="handlePaste"></el-input>
                    </div>
                    
                  </div>
                  <div class="exam-contetn-text-read">
                    <div class="exam-contetn-text-read-left">
                      <p class="exam-contetn-text-read-left-raw" v-if="item.correctFlag==1">回答正确</p>
                      <p class="exam-contetn-text-read-left-raw" style="color: #d13c0a;" v-else>回答错误</p>
                      <p class="exam-contetn-text-read-left-score">得分：{{item.customerScore?item.customerScore:0}}分</p>
                    </div>
                    <div class="exam-contetn-text-read-right">
                      <p class="exam-contetn-text-read-right-difficulty">难度：</p>
                      <el-rate disabled v-model="item.difficult" text-color="#ff8526" ></el-rate>
                    </div>
                  </div>
                  <div class="exam-contetn-text-read-left-answer">
                    <p>正确答案：{{ item.correct }}</p>
                    <p>用户答案：{{ item.answerContent }}</p>
                  </div>
                  <!-- <div class="exam-contetn-text-learning">
                    <p class="exam-contetn-text-learning-key">知识点：</p>
                    <div class="exam-contetn-text-learning-val">
                      <p>知识点知识点知识点知识</p>
                      <p>知识点知识点知识点知识知识点知识</p>
                      <p>知识点知识点知识点知识</p>
                    </div>
                  </div> -->
                  <div class="exam-contetn-text-analysis">
                    <p class="exam-contetn-text-analysis-key">解析：</p>
                    <p class="exam-contetn-text-analysis-val" v-html="item.analyze"></p>
                  </div>
                </li>
              </ul>
              <ul v-else>
                <li v-for="item,index in questions" :key="index" v-if="item.correctFlag != 1">
                  <p class="exam-contetn-text-ranking">第{{index+1}}题
                    <span v-if="item.questionType==1">【单选题】</span>
                    <span v-else-if="item.questionType==2">【多选题】</span>
                    <span v-else-if="item.questionType==3">【判断题】</span>
                    <span v-else-if="item.questionType==4">【填空题】</span>
                  </p>
                  <div class="exam-contetn-text-title">
                    <p>{{item.title}}（{{item.score}}分）</p>
                  </div>
                  <div class="exam-contetn-text-radio">
                    <!-- 单选题 -->
                    <el-radio-group v-model="item.answerContent" v-if="item.questionType==1">
                      <el-radio disabled :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{itemi.prefix}} {{itemi.content}}</el-radio>
                    </el-radio-group>

                     <!-- 多选题 -->
                    <el-checkbox-group v-model="item.answers" v-else-if="item.questionType==2">
                      <el-checkbox disabled :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{itemi.prefix}} {{itemi.content}}</el-checkbox>
                    </el-checkbox-group>

                    <!-- 判断题 -->
                    <el-radio-group v-model="item.answerContent" v-else-if="item.questionType==3">
                      <el-radio disabled :label="itemi.prefix" v-for="itemi,indexi in item.items" :key="indexi">{{itemi.prefix}} {{itemi.content}}</el-radio>
                    </el-radio-group>

                    <!-- 填空题 -->
                    <div class="exam-contetn-text-input" v-for="itemi,indexi in item.answerContent" :key="indexi" v-else-if="item.questionType==4">
                      <p>{{ indexi+1 }}.</p>
                      <el-input disabled :placeholder="itemi" @paste.native.capture.prevent="handlePaste"></el-input>
                    </div>
                  </div>
                  <div class="exam-contetn-text-read">
                    <div class="exam-contetn-text-read-left">
                      <p class="exam-contetn-text-read-left-raw" v-if="item.correctFlag==1">回答正确</p>
                      <p class="exam-contetn-text-read-left-raw" style="color: #d13c0a;" v-else>回答错误</p>
                      <p class="exam-contetn-text-read-left-score">得分：{{item.customerScore}}分</p>
                    </div>
                    <div class="exam-contetn-text-read-right">
                      <p class="exam-contetn-text-read-right-difficulty">难度：</p>
                      <el-rate disabled v-model="item.difficult" text-color="#ff8526" ></el-rate>
                    </div>
                  </div>
                  <div class="exam-contetn-text-read-left-answer">
                    <p>正确答案：{{ item.correct }}</p>
                    <p>用户答案：{{ item.answerContent }}</p>
                  </div>
                  <div class="exam-contetn-text-analysis">
                    <p class="exam-contetn-text-analysis-key">解析：</p>
                    <p class="exam-contetn-text-analysis-val" v-html="item.analyze"></p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import { getExamResult } from '../../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      signId:'',
      ifPractice:0,
      item:{},
      couponChecked:false,
      radio: 1,
      input:'',
      checked:false,
      questions:[],
      correctArray:[]
    }
  },
  // 注册组件
  components: {
    navcon,
    footers,
  },
  mounted(){
    
  },
  created() {
    this.signId = this.$route.query.id;
    this.ifPractice = this.$route.query.ifPractice;
    this.getExamResult();
  },
  
  methods:{
    // 获取考试题目
    async getExamResult(){
      let params = {
        signId:this.signId,
        ifPractice:this.ifPractice
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await getExamResult(params).then(res => {
        loading.close();
        this.item = res.data;
        this.questions = res.data.examPaperViewModel.questions;
        this.questions.forEach((item,i) => {
          this.questions[i].correctFlag = item.correctFlag
          if(item.questionType==2){
            this.questions[i].answers = item.answerContent.split(',')
            console.log(this.questions[i])
          }
          if(item.questionType==4){
            item.answerContent = this.questions[i].answerContent.split(',');
          }
        })
      })
    }
  }
}
</script>
<style scoped>
  .breadcrumb {
    padding: 30px 0;
  }
  .exam-contetn{
    display: flex;
  }
  .exam-contetn-text{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    margin-left: 30px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-bottom: 50px;
  }
  .exam-contetn-text ul li{
    margin-bottom: 40px;
  }
  .exam-contetn-text-ranking{
    font-size: 14px;
    color: black;
    margin-bottom: 16px;
    font-weight: 600;
  }
  .exam-contetn-text-ranking span{
    font-size: 14px;
    color: #f25901;
    font-weight: 500;
  }
  .exam-contetn-text-title p{
    font-size: 13px;
    color: black;
  }
  .exam-contetn-text-title img{
    width: 280px;
    margin-top: 12px;
  }
  .exam-contetn-text-radio{
    margin-top: 16px;
  }
  .el-radio-group, .el-checkbox-group{
    display: grid;
  }
  .exam-contetn-text /deep/ .el-radio__input.is-checked .el-radio__inner, .exam-contetn-text /deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: #f15a01;
    background: #f15a01;
  }
  .exam-contetn-text /deep/ .el-radio__input.is-checked+.el-radio__label, .exam-contetn-text /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #4f4f4f;
  }
  .head /deep/  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #4f4f4f;
  }
  .head /deep/  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #4f4f4f;
  }
  .head /deep/  .el-checkbox__input.is-checked .el-checkbox__inner{
    border-color: #f15a01;
    background: #f15a01;
  }
  .head /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
    border-color: #f15a01;
  }
  .head /deep/ .el-checkbox__inner:hover{
    border-color: #f15a01;
  }
  .exam-contetn-text /deep/ .el-checkbox__inner{
    border-radius: 50%;
  }
  .exam-contetn-text /deep/ .el-radio, .el-checkbox{
    padding: 4px 0;
    margin: 10px 0;
  }
  .exam-contetn-text /deep/ .el-radio__label,.el-checkbox__label{
    font-size: 13px;
  }

  .exam-contetn-text-input{
    display: flex;
    align-items:center;
    margin-bottom: 14px;
  }
  .exam-contetn-text-input p{
    font-size: 14px;
    color: black;
    margin-right: 6px;
  }
  .exam-contetn-text-input input{
    width: 100%;
    font-size: 12px;
  }


  .exam-contetn-item{
    background: #fff;
    padding: 30px 16px 20px;
    border-radius: 8px;
    margin-bottom: 50px;
  }
  .exam-contetn-item-title{
    font-size: 15px;
    color: black;
    line-height: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .exam-contetn-item-score{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }
  .exam-contetn-item-score span{
    color: #9a9a9a;
    font-size: 13px;
  }
  .exam-contetn-item ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .exam-contetn-item ul li{
    width: 30px;
    height: 30px;
    margin: 6.8px;
    background: #FFF2F2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 4px;
    color: #fff;
  }
  .exam-contetn-item ul li img{
    width: 100%;
    border-radius: 8px;
    margin-bottom: 10px;
  }
  .exam-contetn-item ul li p{
    font-size: 13px;
    color: black;
  }
  
  .exam-contetn-item-scantron{
    background: #f8f9fb;
    padding: 16px 10px 12px;
    border-radius: 6px;
    margin-bottom: 10px;
  }
  .exam-contetn-item-scantron-p{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .exam-contetn-item-scantron-card{
    font-size: 13px;
    color: black;
  }
  .exam-contetn-item-scantron-type{
    font-size: 12px;
    color: #6e6e6e;
  }
  .exam-contetn-item-scantron-state{
    display: flex;
    align-items: center;
  }
  .exam-contetn-item-scantron-state-imgs{
    display: flex;
    align-items: center;
    margin-right: 30px;
  }
  .exam-contetn-item-scantron-state-imgs p{
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 6px;
  }
  .exam-contetn-item-scantron-state-imgs span{
    color: #656767;
    font-size: 12px;
  }

  .exam-contetn-text-read{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .exam-contetn-text-read-left, .exam-contetn-text-read-right,.exam-contetn-text-read-left-answer{
    display: flex;
    align-items: center;
  }
  .exam-contetn-text-read-left-raw{
    padding: 4px 12px;
    background: #eaf8ed;
    color: #4cc16e;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 14px;
  }
  .exam-contetn-text-read-left-score{
    color: black;
    font-size: 12px;
  }
  .exam-contetn-text-read-left-answer{
    margin-bottom: 10px;
  }
  .exam-contetn-text-read-left-answer p{
    font-size: 13px;
    color: #6a6a6a;
    margin-right: 30px;
  }
  .exam-contetn-text-read-right-difficulty{
    color: black;
    font-size: 12px;
  }
  .exam-contetn-text-learning,.exam-contetn-text-learning-val{
    display: flex;
    align-items: center;
  }
  .exam-contetn-text-learning-key{
    font-size: 13px;
    color: #6a6a6a;
    margin-right: 6px;
  }
  .exam-contetn-text-learning-val{
    flex-wrap: wrap;
    flex: 1;
  }
  .exam-contetn-text-learning-val p{
    padding: 2px 10px;
    background: #fff2e9;
    color: #6c6966;
    border-radius: 4px;
    font-size: 12px;
    margin: 5px 0;
    margin-right: 8px;
  }
  .exam-contetn-text-analysis{
    background: #fafafa;
    padding: 16px;
    border-radius: 8px;
    margin-top: 10px;
  }
  .exam-contetn-text-analysis-key{
    font-size: 13px;
    color: black;
    margin-bottom: 10px;
  }
  .exam-contetn-text-analysis-val{
    font-size: 12px;
    color: #6c6c6c;
  }
  .head{
    margin-left: 30px;
    background: #f2f2f2;
    padding: 6px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .head .title{
    border-left: 3px solid #ff4900;
    padding-left: 10px;
    font-size: 14px;
    line-height: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/views/exam/analysis.vue